<template>
	<div class="lobby-theme-menu-bar">
		<ul class="lobby-theme-menu-bar-inner nav navbar-nav">
			<li class="dropdown" v-for="menu in menus"
			    :class="widthClass">
				<a class="dropdown-toggle" :class="{'active':isModuleActive(menu)}"
				   @click.stop.prevent="menu.click()">{{menu.name}}</a>
				<ul class="dropdown-menu" v-if="menu.menus && menu.menus.length">
					<li v-for="menu1 in menu.menus">
						<a @click.stop.prevent="menu1.click()">{{menu1.name}}</a>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</template>
<script>
	import {startWith} from "../../../../common/filter/str";

	export default {
		props: {
			menus: {
				type: Array,
				required: true
			},
			autoLength: {
				type: Boolean,
				required: false,
				"default": false
			}
		},
		computed: {
			widthClass(){
				if (this.autoLength) {
					return "auto-length";
				} else {
					return 'menus-length-' + this.menus.length;
				}
			},
			topic(){
				return this.$route.meta.topic;
			}
		},
		components: {},
		methods: {
			isModuleActive(menu) {

				return startWith(location.pathname, menu.getUrl());

			}

		},
		watch: {
			'$route' (to, from) {
				this.$forceUpdate();
				this.topic.refreshActiveMenus();
			}
		},
		mounted(){
			this.topic.refreshActiveMenus();
		}
	}
</script>


<style lang="less" rel="stylesheet/less">

	.lobby-theme-menu-bar {

		@font-color: #ddd;
		@font-highlight: white;
		@main-color: #333;
		@menu-bg-color: transparent;
		@hover-menu-bg-color: #000;
		@hover-second-menu-bg-color: @hover-menu-bg-color;

		@import "css/MenuBarView";

	}


</style>



// WEBPACK FOOTER //
// MenuBarView.vue?e34ec8d4